import type { ComponentProps, PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

type DivProps = ComponentProps<'div'>

function StepPropostaRoot({ children, className, ...props }: PropsWithChildren<DivProps>) {
  return (
    <div className={cn('bg-foreground mx-auto max-w-6xl p-6 pb-30 md:pb-6', className)} {...props}>
      {children}
    </div>
  )
}

function StepPropostaHeader({ children, className, ...props }: PropsWithChildren<DivProps>) {
  return (
    <div className={cn('mb-6 flex items-end justify-between space-y-2', className)} {...props}>
      {children}
    </div>
  )
}

function StepPropostaHeaderTitle({ children, className, ...props }: PropsWithChildren<ComponentProps<'h1'>>) {
  return (
    <h1 className={cn('text-md text-center font-normal text-gray-800 uppercase md:text-left', className)} {...props}>
      {children}
    </h1>
  )
}

function StepPropostaHeaderDescription({ children, className, ...props }: PropsWithChildren<ComponentProps<'p'>>) {
  return (
    <p className={cn('mt-1 text-sm text-gray-500', className)} {...props}>
      {children}
    </p>
  )
}

function StepPropostaHeaderAction({ children, className, ...props }: PropsWithChildren<DivProps>) {
  return (
    <div className={cn('flex items-center', className)} {...props}>
      {children}
    </div>
  )
}

function StepPropostaHeaderContent({ children, className, ...props }: PropsWithChildren<DivProps>) {
  return (
    <div className={cn('flex flex-col', className)} {...props}>
      {children}
    </div>
  )
}

function StepPropostaContent({
  children,
  className,
  hasBorder,
  ...props
}: PropsWithChildren<DivProps & { hasBorder?: boolean }>) {
  return (
    <div
      className={cn(
        'mt-6 flex flex-wrap gap-4',
        hasBorder ? 'border border-neutral-100 p-4' : 'border-none',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

function StepPropostaFooter({ children, className, ...props }: PropsWithChildren<DivProps>) {
  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 z-50 mt-8 w-full border-t bg-white px-4 py-3 md:static md:px-0 md:py-0',
        className,
      )}
      {...props}
    >
      <div className={cn('flex w-full flex-row justify-between gap-4 pt-4 pb-4 md:gap-0', className)}>{children}</div>
    </div>
  )
}

export {
  StepPropostaRoot,
  StepPropostaHeader,
  StepPropostaHeaderTitle,
  StepPropostaHeaderDescription,
  StepPropostaHeaderAction,
  StepPropostaHeaderContent,
  StepPropostaContent,
  StepPropostaFooter,
}
